/**
 * 屏幕 1：生成中（雪屏密度飙升 + 加载文字 + 错误重试）
 */

import { createDenseSnow } from "../snow";

export interface Screen1Deps {
  root: HTMLElement;
  onRetry: () => void;
  onCancel: () => void;
}

export interface Screen1Controller {
  destroy: () => void;
  showError: (msg: string) => void;
}

export function createScreen1(deps: Screen1Deps): Screen1Controller {
  const { root, onRetry, onCancel } = deps;

  const screen = document.createElement("div");
  screen.className = "screen-1";

  const destroySnow = createDenseSnow(root);

  const loader = document.createElement("div");
  loader.className = "loader";
  loader.innerHTML = '<span>信号传输中</span><span class="dots"></span>';
  screen.appendChild(loader);

  const errBox = document.createElement("div");
  errBox.className = "err";
  errBox.style.display = "none";
  errBox.innerHTML = `
    <div class="msg"></div>
    <button class="retry">重试</button>
    <button class="retry secondary">返回</button>
  `;
  screen.appendChild(errBox);

  const errMsg = errBox.querySelector(".msg") as HTMLDivElement;
  const retryBtn = errBox.querySelectorAll(".retry")[0] as HTMLButtonElement;
  const cancelBtn = errBox.querySelectorAll(".retry")[1] as HTMLButtonElement;

  retryBtn.addEventListener("click", () => {
    errBox.style.display = "none";
    loader.style.display = "block";
    onRetry();
  });
  cancelBtn.addEventListener("click", () => onCancel());

  root.appendChild(screen);

  const showError = (msg: string) => {
    loader.style.display = "none";
    errBox.style.display = "flex";
    errMsg.textContent = `信号丢失：${msg}`;
  };

  const destroy = () => {
    destroySnow();
    screen.remove();
  };

  return { destroy, showError };
}
